<template>
    <v-ons-page>

        <div class="content-inner">

            <template v-if="outlet != null">

                <v-ons-list>
                    <div class="main-header main-header-spaced">Opening times</div>
                    <v-ons-list-item>
                        <div class="center">Now</div>
                        <div class="right">{{ outlet.opening_times_info.status }}</div>
                    </v-ons-list-item>
                    <v-ons-list-item v-for="(day_times, index) in outlet.opening_times_info.times"
                        v-bind:key="index">
                        <div class="center">{{ day_times.day }}</div>
                        <div class="right">
                            <template v-for="time in day_times.opening_times">
                                {{ time.open }} to {{ time.closed }}<br>
                            </template>
                        </div>
                    </v-ons-list-item>
                </v-ons-list>



            </template>
        </div>

    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {

        methods: {

        },

        computed: {
            ...mapGetters([
                'outlet',
            ]),
        },

    }
</script>

<style scoped>
    .outlet-details {
        text-align: center;
    }

    .outlet-tags {
        text-align: center;
        padding-left: 0px;
    }

    .outlet-tags li {
        display: inline-block;
        margin-left: 2px;
        margin-right: 2px;
    }

    .outlet-tags li:not(:last-child):after {
        content: ' |';
    }

    .postcode-list {
        width: 100%;
        margin-top: 15px;
    }

    .postcode-list ul {
        margin-top: 5px;
        list-style: none;
        padding-left: 0;
    }

    .order-options-list ons-list-item .left {
        align-items: flex-start;
    }
</style>


// WEBPACK FOOTER //
// src/js/components/outlets/tabs/opening_times.vue